import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-copy">
          © 2026 parthmerchant.com — All Rights Reserved
        </span>
        <a href="https://admin.parthmerchant.com" className="footer-admin-link" aria-label="Admin">Admin Access</a>
      </div>
    </footer>
  );
}
